import { Modal, Stack, Text, Title } from '@mantine/core';
import { useRouter } from 'next/navigation';
import FAIcon from '../FAIcon';
import { useProfileContext } from '@/context/Profile';
import { isUserRealtor } from '@/utils/profile';
import Button from '../Button';

interface BuyerVerificationModalProps {
  opened: boolean;
  onClose: () => void;
}

const BuyerVerificationModal: React.FC<BuyerVerificationModalProps> = ({ opened, onClose }) => {
  const router = useRouter();
  const { userRole } = useProfileContext();
  const isRealtor = isUserRealtor(userRole);

  const handleCompleteProfile = () => {
    onClose();
    if (isRealtor) {
      router.push('/profile/realtor?tab=Realtor+Client+Management');
    } else {
      router.push('/profile/buyer');
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size="md"
      radius="lg"
      withCloseButton
      styles={{
        title: {
          fontWeight: 600,
          fontSize: '1.5rem',
        },
      }}
    >
      <Stack align="center" gap="lg" py="md">
        <FAIcon name="user-check" size={48} c="var(--color-primary)" />
        
        <Title order={2} ta="center">
          {isRealtor ? "Document Review Service" : "Complete Your Buyer/User Profile"}
        </Title>
        
        <Text c="dimmed" ta="center" size="lg">
          {isRealtor 
            ? "This service is exclusively available for buyers. As a realtor, you can invite your buyers to use this service."
            : "To proceed with the payment, please complete your buyer profile first. This helps us provide you with the best service possible."}
        </Text>

        <Stack gap="xs" w="100%">
          <Button
            component="button"
            size="large"
            variant="filled"
            color="dark"
            onClick={handleCompleteProfile}
            fullwidth
            transition={false}
            expandOnHover={false}
          >
            {isRealtor ? "Invite a Buyer/User" : "Complete Profile"}
          </Button>
          
          <Button
            component="button"
            size="large"
            variant="outline"
            color="dark"
            onClick={onClose}
            fullwidth
            transition={false}
            expandOnHover={false}
          >
            Maybe Later
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default BuyerVerificationModal; 